import React, { useEffect, useMemo, useState, useCallback } from "react";
import { Button } from "react-bootstrap";
import useBulkAssigneeStore from "./store";
import { toast } from "react-toastify";
import { Checkbox, Select } from "antd";
import useStatsStore from "modules/engagement_report/engagement_stats/store";

function BulkAssignee() {
  const { users, fetchUserData } = useStatsStore();
  const [resolveFlag, setResolveFlag] = useState(false);
  const { addAssigneeLoading, addAssigneeData, resolveAssigneeData, getResolveAssigneeData } = useBulkAssigneeStore();
  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    fetchUserData();
    getResolveAssigneeData();
  }, [fetchUserData, getResolveAssigneeData]);

  const filterAlreadyAssigned = useCallback((users, assignedUsers) => {
    const assignedUserIds = assignedUsers.assignees?.map(user => user.userId) || [];
    return Array.isArray(users) ? users.filter(user => !assignedUserIds.includes(user.user.id)) : [];
  }, []);

  const mappedData = useMemo(() => {
    const availableUsers = filterAlreadyAssigned(users, resolveAssigneeData);
    return availableUsers?.map((item) => ({
      ...item,
      label: item.user?.first_name,
      value: item.user.id,
    })) || [];
  }, [users, resolveAssigneeData, filterAlreadyAssigned]);

  const handleChange = (selectedValues) => {
    const selectedData = mappedData.filter((option) =>
      selectedValues.includes(option.value)
    );
    setSelectedOptions(selectedData);
  };

  const handleSubmit = () => {
    let payload;
    if (resolveFlag) {
      payload = selectedOptions.map((item) => ({
        firstName: item.user.first_name,
        email: item.user.email,
        userId: item.user.id,
        isResolved: true,
      }));
    } else {
      payload = selectedOptions.map((item) => ({
        firstName: item.user.first_name,
        email: item.user.email,
        userId: item.user.id,
      }));
    }
    if (payload.length) {
      addAssigneeData(payload, toast);
      setSelectedOptions([]);
    }
  };

  return (
    <div className="p-5 d-flex flex-row align-items-center gap-2">
      <div className="d-flex flex-column">
        <Select
          mode="multiple"
          allowClear
          style={{ width: 400 }}
          placeholder="Please select Assignee"
          onChange={handleChange}
          value={selectedOptions.map(option => option.value)}
          options={mappedData}
          showSearch
          filterOption={(input, option) =>
            option.label.toLowerCase().includes(input.toLowerCase())
          }
        />
        <Checkbox onChange={(e) => setResolveFlag(e.target.checked)}>
          Add as Resolved Assignee
        </Checkbox>
      </div>
      <Button
        className="mt-n4"
        style={{ width: 150 }}
        onClick={handleSubmit}
        loading={addAssigneeLoading}
      >
        Assign
      </Button>
    </div>
  );
}

export default BulkAssignee;
